import React, { Component } from "react";
import Faq from "../../forms/faq";
import { nps_knowledge_content, nps_faqs_content } from "../../forms/content";

const INR = "\u20B9";

const formatToInr = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumSignificantDigits: 3,
}).format;

const INCENTIVE_TABLE_ADITYA_HDFC = {
  title: "Incentive for New PRAN (HDFC PFM and Aditya Birla)",
  tableHeaders: ["No of PRAN", "Amount/PRAN (INR)", "% of POP Commission"],
  tableData: [
    ["1 - 50", formatToInr(240), "60%"],
    ["51 - 100", formatToInr(280), "70%"],
    ["101 Onwards", formatToInr(320), "80%"],
  ],
};

const INCENTIVE_TABLE_ICICI = {
  title: "Incentive for New PRAN (ICICI Prudential Life)",
  tableHeaders: ["No of PRAN", "Amount/PRAN (INR)"],
  tableData: [
    ["1-2", formatToInr(120)],
    ["3-5", formatToInr(150)],
    ["6-10", formatToInr(200)],
    ["11-15", formatToInr(225)],
    ["16-25", formatToInr(250)],
    ["26-50", formatToInr(275)],
    ["50 onwards", formatToInr(320)],
  ],
};

const COMMISSION_TABLE_ICICI = {
  title: "Commission based on contribution (ICICI Prudential Life)",
  tableHeaders: [
    "Total contribution received per Quarter",
    "Contribution fee per PRAN",
  ],
  tableData: [
    [`0 - ${INR}2.99 Lakh`, `0.15% or ${formatToInr(9)} whichever is higher`],
    [
      `${INR} 3Lakhs to ${INR}9.99 Lakhs`,
      `0.20% ${formatToInr(12)} whichever is higher`,
    ],
    [
      `${INR} 10 Lakhs onwards`,
      ` 0.25% or ${formatToInr(15)} whichever is higher (Maximum ${formatToInr(
        12500
      )} per
      contribution)`,
    ],
  ],
};

export default class aboutNps extends Component {
  render() {
    return (
      <div className="container-margin">
        <div>
          <div className="customer-support-email">
            Customer Support Email :{" "}
            <a href="mailto:npsdistributorsupport@kfintech.com">
              npsdistributorsupport@kfintech.com
            </a>
          </div>
          <div className="nps-head">
            Distribute National Pension System to your customers
          </div>
          <h5 className="nps-about-header nps-about-header-underline">
            Get Started with your NPS Agent Empanelment in 3 Easy Steps
          </h5>
          <ol className="nps-list">
            <li>Enter your basic personal details </li>
            <br />
            <li>Enter bank details</li>
            <br />
            <li>Upload documents (PAN/Cancelled Check / Address Proof)</li>
          </ol>
          <h5 className="nps-about-header">Boost your Earnings</h5>
          <div className="flex">
          <CommonTable {...INCENTIVE_TABLE_ADITYA_HDFC} />
          <CommissionsTable />
          </div>
          <div className="flex">
          <CommonTable {...INCENTIVE_TABLE_ICICI} />
          <CommonTable {...COMMISSION_TABLE_ICICI} />
          </div>

          <div className="terms_condtions">
            <h5 style={{ color: "rgb(46,118,194)" }}>
              Terms and Condition for Incentive/Commission
            </h5>
            <ol className="terms_condtions_list">
              <li>
                Structure of Incentive /Commission is subject to the terms of
                empanelment of the POP{" "}
              </li>
              <li>
                Any dispute in the commission to be addressed and resolved with
                the respective POP. Kfintech role is limited to facilitating the
                empanelment of the distributors and providing data of the
                subscribers.
              </li>
              <li>
                Payment of brokerage will be paid as per the calculation made at
                end of every month{" "}
              </li>
              <li>
                Brokerage Slabs will be retrospective based on the slab rates{" "}
              </li>
              <li>Commission or Incentive will be inclusive of GST </li>
              <li>
                You are advised to adhere to the code of conduct of agent as
                expected by PFRDA and the POP can take action if in case of
                deviation{" "}
              </li>
            </ol>
          </div>
        </div>

        <h5 className="nps-about-header nps-about-header-underline">
          NPS Knowledge Base
        </h5>
        {nps_knowledge_content.map((content, index) => (
          <Faq header={content.header} body={content.body} />
        ))}
        <h5 className="nps-about-header nps-about-header-underline">FAQ's</h5>
        {nps_faqs_content.map((content, index) => (
          <Faq header={content.header} body={content.body} />
        ))}
      </div>
    );
  }
}

const CommonTable = ({ title, tableHeaders, tableData }) => {
  return (
    <table className="table1-nps">
      <tr id="ROW">
        <th colspan={tableHeaders?.length.toString()}>{title}</th>
      </tr>
      <tr id="ROW">
        {tableHeaders.map((header) => (
          <td key={header} style={{ fontWeight: 500 }}>
            {header}
          </td>
        ))}
      </tr>
      {tableData.map((eachRow, index) => (
        <tr key={index}>
          {eachRow.map((dataCell) => (
            <td key={dataCell}>{dataCell}</td>
          ))}
        </tr>
      ))}
    </table>
  );
};

const CommissionsTable = ({ title }) => {
  return (
    <table className="table2-nps">
      <tr id="ROW">
        <th colspan="4">
          Commision based on Contribution (HDFC PFM and Aditya Birla)
        </th>
      </tr>
      <tr id="ROW">
        <td style={{ fontWeight: 500 }}>Contribution</td>
        <td style={{ fontWeight: 500 }} colspan="3">
          No of Applications
        </td>
      </tr>
      <tr id="ROW">
        <td></td>
        <td>1 - 50</td>
        <td>51 - 100</td>
        <td>101 Onwards</td>
      </tr>
      <tr>
        <td> &lt;={formatToInr(6000)}</td>
        <td>{formatToInr(18)} </td>
        <td>{formatToInr(21)}</td>
        <td>{formatToInr(24)} </td>
      </tr>
      <tr>
        <td>
          &gt;{formatToInr(6000)}&lt;{INR}50 Lakh
        </td>

        <td>0.30%</td>
        <td>0.35% </td>
        <td>0.40%</td>
      </tr>
      <tr>
        <td>&gt;= 50 Lakh</td>
        <td> {formatToInr(15000)}</td>
        <td> {formatToInr(17500)} </td>
        <td> {formatToInr(20000)} </td>
      </tr>
      <tr>
        <td>% of POP Commission</td>
        <td>60%</td>
        <td>70%</td>
        <td>80%</td>
      </tr>
    </table>
  );
};
